import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { GoodsReceiptSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { createGoodsReceiptSearchSchema } from "@/screens/WarehouseReceiving/schemas"
import { CheckedInGoodsReceiptsContainer } from "@/screens/WarehouseReceiving/subfeatures/CheckedIn/components"

export const Route = createFileRoute("/app/warehouse-receiving/_layout/checked-in")({
  validateSearch: zodValidator(createGoodsReceiptSearchSchema(GoodsReceiptSortField.CheckedInOn, SortingOrder.Desc)),
  component: () => <CheckedInGoodsReceiptsContainer />,
})
